import { SeuApiConverter, SeuConfigInputItem } from '@seu-types';

export const configInputConverter: SeuApiConverter<
  SeuConfigInputItem,
  SeuConfigInputItem
> = {
  fromApi: (input) => {
    let value: string | string[] | number | boolean | undefined;
    if (
      typeof input.unitValue.value === 'number' ||
      typeof input.unitValue.value === 'string' ||
      typeof input.unitValue.value === 'boolean' ||
      Array.isArray(input.unitValue.value)
    ) {
      value = input.unitValue.value;
    }

    if (value === undefined || value === null) {
      value = '';
    }

    return {
      ...input,
      unitValue: {
        ...input.unitValue,
        value,
      },
    };
  },
  toApi: (input) => {
    return {
      ...input,
    };
  },
};
